import { api } from '@/shared/api/http'
import type { LanguageId } from '@/features/language/types'
import type { Nickname } from './types'

/**
 * 닉네임을 읽고 쓰는 자리.
 *
 * 내 정보 조회에 싣지 않는다. 이 값을 그리는 화면이 설정 하나뿐이라 화면을 옮길 때마다 도는
 * 응답에 자유 문자열을 싣지 않기로 했다. 그래서 설정이 자기 요청으로 읽는다.
 *
 * 값을 주소에 담지 않는다. 주소는 브라우저 이력과 접근 로그, Referer에 남아 본문과 다른
 * 수명을 갖는다.
 */
export function fetchNickname(signal?: AbortSignal): Promise<Nickname> {
  return api.get<Nickname>('/me/nickname', signal ? { signal } : {})
}

export function updateNickname(nickname: string): Promise<Nickname> {
  return api.put<Nickname>('/me/nickname', { nickname })
}

/**
 * 새 닉네임 후보 하나를 받는다. 저장하지 않는다.
 *
 * 낱말 목록의 정본이 서버 한 곳이라 화면이 스스로 짓지 않는다. 목록이 두 곳에 있으면 가입 때
 * 지은 닉네임과 다시 지은 닉네임이 다른 결로 갈린다.
 */
export function suggestNickname(languageId: LanguageId, signal?: AbortSignal): Promise<Nickname> {
  return api.get<Nickname>(
    `/me/nickname/suggestion?languageId=${languageId}`,
    signal ? { signal } : {},
  )
}
